"use strict";
/**
 * Unified Flagging Domain — DynamoDB Database Record Types
 *
 * Records for user-submitted content flags, idempotency guards,
 * moderation notes, flagged moderator content, and craft room policy violations.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlagContentType = void 0;
// ============================================================================
// UnifiedFlagRecord — user-submitted content flag
// ============================================================================
const entity_type_1 = require("../enums/entity-type");
Object.defineProperty(exports, "FlagContentType", { enumerable: true, get: function () { return entity_type_1.FlagContentType; } });
